import { Api } from 'models/services/api';
import { UpdateFranchiseeQuery } from 'models/services/graphql';

import { FranchiseeData, FranchiseeDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: FranchiseeDataToSave;
};

const RequestQuery = `
  mutation UpdateFranchisee($id: ID!, $input: FranchiseeInput!) {
    ${UpdateFranchiseeQuery}
  }
`;

type ResponseData = {
  data: {
    updateFranchisee: FranchiseeData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: FranchiseeData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateFranchisee;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };